<template>
  <div id="order">
    <div class="order_iframe" style="">
      <iframe id="myiframe" style="" :src="url_order" ></iframe>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import $ from 'jquery'

export default {
  name: 'Order',
  data () {
    return {
      params: '',
      url_order: ''
    }
  },
  methods: {
    getOrder: function () {
      var area_id = this.global.area_id
      if (this.params.sid) {
        area_id = this.params.sid
      }
      if (this.global.hashParam['sid']) {
        area_id = this.global.hashParam['sid']
      }
      var config = this.global.config
      var jieshu = ''
      // 2021及之后
      jieshu = parseInt(config[area_id].jieshu)
      document.title = '参会购票—第' + jieshu + '届 MPD工作坊' + config[area_id].title + '站' + '报名'
      let url0 = this.global.url.order.url + '?sid=' + area_id
      let hashqd = ''
      let hashshare = ''
      hashqd = this.global.hashParam['qd']
      hashshare = this.global.hashParam['share']
      if (hashqd) {
        url0 += '&qd=' + hashqd
      }
      if (hashshare) {
        this.url_order = url0 + '&share=' + hashshare
      } else {
        this.url_order = url0
      }
    }
  },
  created () {
    // console.log('order param: ', this.global.hashParam)
    this.params = this.$route.query
    this.getOrder()
  },
  watch: {
    '$route' (to, from) { // 监听路由是否变化
      if (to.query.sid.toString() !== from.query.sid.toString()) {
        this.params = this.$route.query
        this.getOrder()
      }
    }
  }
}
</script>

<style scoped>
.order_iframe{
 padding-top: 120px;
}
#myiframe{
 width: 100%;
 border:none;
 height: 1700px;
}
@media(max-width:767px){
 .order_iframe{
  padding-top: 50px;
 }
 #myiframe{
  height: 2400px;
 }
}
</style>



// WEBPACK FOOTER //
// src/views/Order.vue